import React from "react";
import { CSVLink } from "react-csv";
import Button from "@mui/material/Button";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

interface TimeseriesEntry {
  day: string;
  value: number | null;
  previousYearValue?: number | null;
}

interface SgipCsvDownloadProps {
  timeseriesData: TimeseriesEntry[];
  filename: string;
  headers: { label: string; key: string }[];
}

const SgipCsvDownload: React.FC<SgipCsvDownloadProps> = ({ timeseriesData, filename, headers }) => {
  // Map data for CSVLink
  const csvData = timeseriesData.map((entry) => {
    const row: Record<string, string | number | null> = {};
    headers.forEach(({ key }) => {
      row[key] = entry[key as keyof TimeseriesEntry] ?? "";
    });
    return row;
  });

  return (
    <CSVLink
      data={csvData}
      headers={headers}
      filename={filename}
      target="_blank"
      rel="noreferrer"
      style={{ display: "flex" }}
      data-testid="sgip-csv-download"
    >
      <Button variant="outlined" color="primary" size="large" sx={{ minWidth: "0px", px: "7px" }}>
        <DownloadOutlinedIcon fontSize="inherit" sx={{ fontSize: "25px" }} />
      </Button>
    </CSVLink>
  );
};

export default SgipCsvDownload;
